import dayjs from 'dayjs';
const customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);
import { BOOKING_TIME_TYPES } from '../components/booking/constants';

export const STANDARD_DATE_FORMAT = 'YYYY-MM-DD';

export function getTimePeriods(today = false) {
  const timePeriods = [];
  if (today) {
    timePeriods.push(BOOKING_TIME_TYPES.ASAP);
  }

  const tomorrow = getTomorrow();
  let time = today ? dayjs().add(3, 'hour') : getNextDay();
  let endTime = dayjs();

  while (endTime < tomorrow) {
    timePeriods.push(getTimePeriod(time));
    time = time.add(1, 'hour');
    endTime = endTime.hour(time.get('hour') + 1);
  }

  return timePeriods;
}

function getTimePeriod(date) {
  const initialTime = getExactTime(dayjs(date), 0);
  const endTime = getExactTime(dayjs(date), 4);
  return timeFormat(initialTime) + ' - ' + timeFormat(endTime);
}

function getExactTime(date, time) {
  return roundMinutes(date).add(time, 'hour');
}

function roundMinutes(date) {
  return date.add(Math.round(date.minute() / 60), 'hour').minute(0).second(0).millisecond(0);
}

export function getTomorrow() {
  return dayjs().add(1, 'day').hour(1).minute(0);
}

function timeFormat(date) {
  return date.hour() + ':00';
}

function getNextDay() {
  return dayjs().add(1, 'day').hour(0).minute(0).second(0);
}

export function getFormattedDate(date) {
  if (isValidDate(date)) {
    return date;
  }
  const formattedDate = dayjs(date, 'DD-MM-YYYY').toDate();
  return isValidDate(formattedDate) ? formattedDate : null;
}

export function isValidDate(date) {
  if (Object.prototype.toString.call(date) === '[object Date]') {
    return !isNaN(date);
  }
  return false;
}

export function getDateSomeYearsAgo(yearsAgo) {
  const someYearsAgo = dayjs().subtract(yearsAgo, 'years');
  return dayjs(someYearsAgo, STANDARD_DATE_FORMAT).toDate();
}

export function getDateYesterday() {
  const yesterday = dayjs().subtract(1, 'day').hour(0).minute(0).second(0);
  return dayjs(yesterday, STANDARD_DATE_FORMAT).toDate();
}

export function getDateFormat(date) {
  return dayjs(date).format('DD.MM.YYYY');
}

export function getDateWithMonthFormat(date) {
  return dayjs(date, 'DD.MM.YYYY').format('DD MMM YYYY');
}

export function getDateWithTimeFormat() {
  return dayjs().format('DD.MM.YYYY-HH:mm:ss');
}

export function getDateRequestFormat(date) {
  return dayjs(date).format(STANDARD_DATE_FORMAT);
}

export function parseRequestDate(date) {
  return dayjs(date, STANDARD_DATE_FORMAT).toDate();
}

export function isToday(date) {
  if (!date) return false;
  return new Date().toDateString() === date.toDateString();
}

export function parseReqDateToReadable(date) {
  return dayjs(date, STANDARD_DATE_FORMAT).format('DD MMM YYYY');
}

export function formatDateWithTime(date, time) {
  if (typeof date === 'string') {
    return date ? dayjs(date, 'DD.MM.YYYY').format(STANDARD_DATE_FORMAT) + 'T' + parseTime(time) : null;
  }
  return date ? dayjs(date).format(STANDARD_DATE_FORMAT) + 'T' + parseTime(time) : null;
}

export function formatDateWithEndTime(date, time) {
  if (!date) return null;
  if (time === BOOKING_TIME_TYPES.ASAP) return null;
  const fixTime = time => time.split(':').map(part => part.padStart(2, '0')).join(':');
  const isoDate = typeof date === 'object'? date.toISOString().split('T')[0]: date.split('.').reverse().join('-');
  const start = dayjs(isoDate + 'T' + fixTime(parseStartTime(time)));
  let end = dayjs(isoDate + 'T' + fixTime(parseEndTime(time)));
  if (start.isAfter(end)) end = dayjs(end).add(1, 'day');
  return end.format(STANDARD_DATE_FORMAT) + 'T' + parseEndTime(time);
}

export function parseStartTime(time) {
  return time.split(' ')[0] + ':00';
}

export function parseEndTime(time) {
  return time.split(' ').pop() + ':00';
}

export function parseTime(time) {
  if (time !== BOOKING_TIME_TYPES.ASAP) {
    return parseStartTime(time);
  }
  return dayjs().format('HH') + ':00:00';
}

export function getETATime(minutes) {
  return dayjs().add(minutes, 'minute').format('HH:mm');
}

export function getVoucherDate(date) {
  return dayjs(date, 'DD/MM/YYYY').format('DD.MM.YYYY');
}

export function toRequestFormat(date) {
  return dayjs(date, STANDARD_DATE_FORMAT).format('DD/MM/YYYY');
}

export function isAdult(dateString) {
  const date = dayjs(dateString)
  const now = dayjs(new Date());
  return now.diff(date, 'year') >= 16;
}
